<template>
  <ul v-if="suggestions.length" class="suggestions-list">
    <li
      v-for="suggestion in suggestions"
      :key="keyField ? suggestion[keyField] : suggestion.id"
      @click="$emit('select', suggestion)"
      class="suggestion-item"
    >
      <slot :suggestion="suggestion">
        {{ suggestion.firstname }} {{ suggestion.lastname }}
        <small v-if="suggestion.email"> — {{ suggestion.email }}</small>
      </slot>
    </li>
  </ul>
</template>

<script setup>
defineProps({
  suggestions: {
    type: Array,
    default: () => []
  },
  keyField: {
    type: String,
    default: 'id'
  }
})

defineEmits(['select'])
</script>

<style scoped>
.suggestions-list {
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid #ddd;
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  position: relative;
  z-index: 40;
}

.suggestion-item {
  padding: 6px 8px;
  margin: 0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.suggestion-item:hover {
  background: var(--primary);
  color: var(--white);
}
</style>
